import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

/**
 * Componente que exibe os preços e economia
 * 
 * @param {object} props - Propriedades do componente
 * @param {string} props.recurrence - Recorrência selecionada (Monthly/Annual)
 * @param {object} props.priceInfo - Informações de preço calculadas
 * @param {string} props.rocketIcon - Caminho para o ícone de foguete
 */
const PriceDisplay = ({ recurrence, priceInfo, rocketIcon }) => {
  const priceDescription = recurrence === "Monthly"
    ? `TOTAL: ${priceInfo.formattedMonthly} por mês`
    : `TOTAL: ${priceInfo.formattedAnnual} por ano`;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      {/* Preço original (riscado) exibido apenas quando o plano anual é selecionado */}
      {recurrence === "Annual" && (
        <Typography
          sx={{
            color: "#666",
            fontSize: "16px",
            textDecoration: "line-through",
            marginBottom: "4px",
            fontWeight:500
          }}
        >
          TOTAL: {priceInfo.formattedOriginalPrice}
        </Typography>
      )}
      
      {/* Preço atual */}
      <Typography
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          color: "#662d91",
          fontSize: "24.221px",
          fontWeight: 700,
        }}
      >
        {priceDescription}
      </Typography>
      
      {/* Chip de economia exibido apenas quando o plano anual é selecionado */}
      {recurrence === "Annual" && (
        <Chip
          label={`Economia de ${priceInfo.formattedSavings}`}
          sx={{
            backgroundColor: "#e6f7e6",
            color: "#1e8e3e",
            borderRadius: "16px",
            marginTop: "8px",
            fontWeight: 700,
            fontSize: "14px"
          }}
          icon={
            <Box sx={{
              width: "16px",
              height: "16px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: "8px",
              color: "white",
              fontSize: "12px"
            }}>
              <img 
                src={rocketIcon} 
                alt="Economia" 
                style={{ width: '16px', height: '16px' }} 
              />
            </Box>
          }
        />
      )}
    </Box>
  );
};

export default React.memo(PriceDisplay);